import Scheduler from '../components/scheduler/Scheduler';
import { Helmet } from 'react-helmet-async';

const MeetingPage = () => {
    return (
        <div>
            <Helmet>
                <title>Room 49 - Book the meeting room</title>
                <meta name="description" content="Need a private space for a client call or catch-up? The meeting room at Room 49 is available to book for short sessions when you need it." />
                <link rel="canonical" href='https://thetypingrooms.co.uk/meeting' />
            </Helmet>
            <div className="page">
                <div className="page-header">
                    <h1>Book the basement</h1>
                </div>
                <div className='page-content'>
                    <p>
                        The private room downstairs has a meeting table, sofa, whiteboard and projector. It's ideal for video calls, quiet work, or small meetings. If you've booked a desk upstairs, you can book the room for up to two one-hour slots a day, up to two weeks in advance. It's just a small room so 3 guests maximum please. The calendar below shows existing bookings—it isn't clickable. To book, just enter your name, email, date and time underneath. It's available to anyone already using our shared workspace in Tunbridge Wells.
                    </p>
                </div>
                <Scheduler />
            </div>
        </div>
    );
};

export default MeetingPage;